import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { ButtonTooltip, Icon, FormikInput } from '../../../components';
import { QuestionDescriptionFields } from './EvaluationScaleShared';

export const PointsScaleLayout = ({ valuePath, questionChoicesAttributes = [], addPointsRow, deletePointsRow }) => {
  const { setFieldValue } = useFormikContext();

  const configIdx = questionChoicesAttributes.findIndex(c => c.kind === 'config');
  const maxValue = parseInt(questionChoicesAttributes[configIdx]?.label || '10', 10);
  const rowChoices = questionChoicesAttributes.filter(c => c.kind === 'row' && !c._destroy);

  const handleMaxChange = e => {
    let val = parseInt(e.target.value, 10);
    if (Number.isNaN(val) || val < 1) val = 1;
    if (val > 100) val = 100;
    if (configIdx >= 0) {
      setFieldValue(`${valuePath}[questionChoicesAttributes][${configIdx}][label]`, String(val));
    }
  };

  return (
    <div className="mt-3">
      <QuestionDescriptionFields
        valuePath={valuePath}
        descriptionPlaceholder="Asigne los puntos que considere que representa su respuesta"
      />
      <div className="mb-3">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
        <label htmlFor={`eval-max-value-${valuePath}`} className="eval-scale-label">
          Valor máximo a evaluar:
        </label>
        <Form.Control
          id={`eval-max-value-${valuePath}`}
          type="number"
          min={1}
          max={100}
          value={maxValue}
          onChange={handleMaxChange}
          className="eval-scale-n-selector"
        />
      </div>

      {rowChoices.map((rowChoice, rowIdx) => {
        const ri = questionChoicesAttributes.indexOf(rowChoice);
        return (
          <div key={rowChoice.id || rowChoice.position} className="eval-points-row">
            <div className="eval-points-label-side">
              <span className="eval-scale-row-label text-muted">Respuesta {rowIdx + 1}:</span>
              <Field name={`${valuePath}[questionChoicesAttributes][${ri}][label]`}>
                {({ field }) => (
                  <FormikInput
                    {...field}
                    value={field.value || ''}
                    maxLength={25}
                    placeholder={`Respuesta ${rowIdx + 1}`}
                    customFormGroupClass="eval-points-label-input mb-0"
                  />
                )}
              </Field>
            </div>
            <div className="eval-points-slider-wrapper">
              <div className="eval-points-minmax">
                <span>0</span>
                <span>{maxValue}</span>
              </div>
              <Form.Control
                type="range"
                min={0}
                max={maxValue}
                defaultValue={0}
                step={1}
                disabled
                className="eval-points-slider"
              />
            </div>
            <ButtonTooltip
              variant="circle-danger"
              className="btn-circle"
              size="sm"
              text="Eliminar fila"
              onClick={() => deletePointsRow(rowIdx)}
              disabled={rowChoices.length <= 1}
            >
              <Icon icon="trash" />
            </ButtonTooltip>
          </div>
        );
      })}

      <Row className="mt-2">
        <Col className="d-flex justify-content-end">
          <Button variant="primary" size="sm" onClick={addPointsRow}>
            Agregar Respuesta
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PointsScaleLayout;
